














































import BaseComponent from '@/components/base-component.vue';
import BaseLogin from '@/components/login/base-login-page.vue';
import UiInputFile from '@/components/UI/input-file.vue';
import { PreAtivacaoIniciarResult } from '@/interfaces/user';
import * as service from '@/services/auth';
import { clearLocalStorage, clearSessionStorage } from '@/services/session-data';
import Component from 'vue-class-component';

@Component({
  components: {
    BaseLogin,
    UiInputFile,
  },
})
export default class PreActivationLogin extends BaseComponent {
  private msg: string = null;
  private msgErro: string = null;
  private msgErroDocs: string = null;
  private res: PreAtivacaoIniciarResult = null;
  private liConcordo: boolean = false;
  private files: any = new Array();
  private fim: boolean = false;
  private multiDoc: boolean = false;

  public form: any = {
    valid: false,
    rules: {
      arquivo: [(v) => !!v || 'Selecione um arquivo'],
    },
  };

  private uuid: string;

  public mounted(): void {
    clearLocalStorage();
    clearSessionStorage();
    this.uuid = this.$route.query.uuid ? this.$route.query.uuid.toString() : null;
    if (!this.uuid) {
      this.showInvalidLink();
    } else {
      this.iniciarForm();
    }
  }

  public iniciarForm(): void {
    this.msg = null;
    this.msgErro = null;
    this.loader.start('Processando...');

    service.initPreActivationLogin(this.uuid).subscribe(
      (res) => {
        this.msg = res.msg;
        this.loader.stop();
        this.res = res;
        this.multiDoc = res.documentosNecs.length > 1;
      },
      (error) => {
        this.msgErro = error.data.message;
        this.loader.stop();
      },
    );
  }

  private showInvalidLink(): void {
    this.dialog.show(
      'error',
      'Link inválido',
      'Link inválido ou expirado',
      'Ok',
      null,
      '',
      null,
    );
  }

  private isFormCompleto() {
    return (
      (this.liConcordo || this.res.ajustes) &&
      this.res.documentosNecs.filter((d) => {
        return !(d as any).file;
      }).length == 0
    );
  }

  private enviar() {
    var files = [];
    var idsDocs = [];
    this.loader.start('Enviando...');
    this.res.documentosNecs.forEach((d) => {
      files.push((d as any).file);
      idsDocs.push(d.id);
    });

    service.saveDocsPreActivationLogin(this.uuid, files, idsDocs).subscribe(
      (r) => {
        this.loader.stop();
        this.dialog.show('alert', 'Concluído', r.toString(), 'Ok', null, '', null);
        this.msg = r.toString();
        this.fim = true;
      },
      (error) => {
        this.loader.stop();
        this.msgErroDocs = error.data.message;
        setTimeout(() => {
          this.msgErroDocs = null;
        }, 10000);
      },
    );
  }
}
